import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// 顺序有意义：两套主题都用 :root[data-theme=...] 选中，同特异性，谁后导入谁在平手时胜出
import './styles/theme-dark.css';
import './styles/theme-light.css';
import './styles/base.css';

// 主题在挂载前定好，避免首屏闪一下。**默认浅色**，与 auto_design 平台一致；
// 两套主题都靠 data-theme 命中，所以这个属性必须始终存在。
const saved = localStorage.getItem('hip.theme');
document.documentElement.setAttribute('data-theme', saved === 'dark' ? 'dark' : 'light');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
